import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import Hidden from '@material-ui/core/Hidden';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import rainbowFlag from "assets/img/rainbow-flag.svg";
import genderEquality from "assets/img/gender-equality.svg";
import hardHat from "assets/img/hard-hat.svg";
import windmill from "assets/img/windmill.svg";
import column from "assets/img/column.svg";
import medicine from "assets/img/medicine.svg";
import racialEquity from "assets/img/racial-equity.svg";
import shieldLock from "assets/img/shield-lock.svg";

// import featuresStyle from "assets/jss/material-kit-react/views/landingPageSections/featuresStyle.jsx";

const aboutMiniStyle = {
  section: {
    padding: "70px 0px",
    textAlign: "center",
    fontSize: "16px",
    color: "white",
    backgroundColor: "#1f1f1f",
    boxShadow:
      "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      padding: "70px",
    },
    "@media (min-width: 992px)": {
    },
    "@media (min-width: 1200px)": {
    },
  },
  gridContainer: {
    marginTop: "10px",
    marginBottom: "20px"
  },
  img: {
    width: "60px",
    height: "60px",
    "@media (min-width: 576px)": {
    width: "70px",
    height: "70px"
    },
    "@media (min-width: 768px)": {
    width: "90px",
    height: "90px"
    },
    "@media (min-width: 992px)": {
    width: "100px",
    height: "100px"
    },
  },
  text: {
    textAlign: "left",
    padding: "0px 30px",
    "@media (min-width: 768px)": {
      textAlign: "center",
      padding: "0px 70px",
    },
  },
  gridItem: {
    paddingLeft: "0px",
    paddingRigh: "0px"
  }
};

class AboutMiniSection extends React.Component {
  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );
    return(
      <div className={classes.section}>
        <GridContainer justify="center" className={classes.gridContainer}>
          <GridItem xs={12}>
            <p className={classes.text}>Our shares. Our votes. Our future.</p>
            <p className={classes.text}>As real human investors, our wellbeing depends on far more than quarterly profits.</p>
          </GridItem>
        </GridContainer>
        <Hidden mdUp>
        <GridContainer justify="center" className={classes.gridContainer}>
            <GridItem xs={8} in={true} className={classes.gridItem}>
              <GridContainer justify="space-between">
                <GridItem xs={2} className={classes.gridItem}>
                  <img className={imageClasses + " " + classes.img} src={genderEquality} alt="Gender Equality"/>
                </GridItem>
                <GridItem xs={2} className={classes.gridItem}>
                  <img className={imageClasses + " " + classes.img} src={windmill} alt="Environment: A windmill"/>
                </GridItem>
                <GridItem xs={2} className={classes.gridItem}>
                 <img className={imageClasses + " " + classes.img} src={column} alt="Democracy: A greek column"/>
                </GridItem>
                <GridItem xs={2} className={classes.gridItem}>
                  <img className={imageClasses + " " + classes.img} src={racialEquity} alt="Racial Equity: Raised fists"/>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </Hidden>
        <Hidden smDown>
          <GridContainer justify="space-around" className={classes.gridContainer}>
            <GridItem xs={1} className={classes.gridItem}>
              <img className={imageClasses + " " + classes.img} src={rainbowFlag} alt="LGBTQ+ Rights: A rainbow flag"/>
            </GridItem>
            <GridItem xs={1} className={classes.gridItem}>
              <img className={imageClasses + " " + classes.img} src={genderEquality} alt="Gender Equality"/>
            </GridItem>
            <GridItem xs={1} className={classes.gridItem}>
             <img className={imageClasses + " " + classes.img} src={hardHat} alt="Work and Labor: A hardhat"/>
            </GridItem>
            <GridItem xs={1} className={classes.gridItem}>
              <img className={imageClasses + " " + classes.img} src={windmill} alt="Environment: A windmill"/>
            </GridItem>
            <GridItem xs={1} className={classes.gridItem}>
              <img className={imageClasses + " " + classes.img} src={column} alt="Democracy: A greek column"/>
            </GridItem>
            <GridItem xs={1} className={classes.gridItem}>
              <img className={imageClasses + " " + classes.img} src={medicine} alt="Healthcare"/>
            </GridItem>
            <GridItem xs={1} className={classes.gridItem}>
             <img className={imageClasses + " " + classes.img} src={racialEquity} alt="Racial Equity: Raised fists"/>
            </GridItem>
            <GridItem xs={1} className={classes.gridItem}>
              <img className={imageClasses + " " + classes.img} src={shieldLock} alt="Privacy and Data Protection"/>
            </GridItem>
          </GridContainer>
        </Hidden>
        <GridContainer justify="center" className={classes.gridContainer}>
          <GridItem xs={12}>
          <p className={classes.text}><span class="brand">We the Shareholders</span> tackles the fundamental challenges of shareholder disenfranchisement, involuntary dissociation, and unfettered wealth-inequality that stand in the way of human investors' ability to engage, influence, and change corporate behavior—challenges that undermine American democracy itself.</p>
          </GridItem>
        </GridContainer>
        <Hidden mdUp>
        <GridContainer justify="center" className={classes.gridContainer}>
            <GridItem xs={8} className={classes.gridItem}>
              <GridContainer justify="space-between">
                <GridItem xs={2} className={classes.gridItem}>
                 <img className={imageClasses + " " + classes.img} src={rainbowFlag} alt="LGBTQ+ Rights: A rainbow flag"/>
                </GridItem>
                <GridItem xs={2} className={classes.gridItem}>
                  <img className={imageClasses + " " + classes.img} src={hardHat} alt="Work and Labor: A hardhat"/>
                </GridItem>
                <GridItem xs={2} className={classes.gridItem}>
                  <img className={imageClasses + " " + classes.img} src={medicine} alt="Healthcare"/>
                </GridItem>
                <GridItem xs={2} className={classes.gridItem}>
                  <img className={imageClasses + " " + classes.img} src={shieldLock} alt="Privacy and Data Protection"/>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </Hidden>
        <GridContainer justify="center" className={classes.gridContainer}>
          <GridItem xs={12}>
          <p className={classes.text}>Join us in restoring corporate democracy and making capitalism sustainable.</p>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(aboutMiniStyle)(AboutMiniSection);